import {
  FETCHING_ASSET,
  FETCHING_ASSET_SUCCEDDED,
  FETCHING_ASSET_FAILED,
  INVALIDATE_ASSET,

  FAVORITING_ASSET_REQUEST,
  FAVORITING_ASSET_SUCCEDDED,
  FAVORITING_ASSET_FAILED,
  UNFAVORITING_ASSET_REQUEST,
  UNFAVORITING_ASSET_SUCCEDDED,
  UNFAVORITING_ASSET_FAILED,

  UPDATING_ASSET,
  UPDATING_ASSET_SUCCEDDED,
  UPDATING_ASSET_FAILED,

  UPLOAD_NEW_ASSET_VERSION_REQUEST,
  UPLOAD_NEW_ASSET_VERSION_SUCCEDDED,
  UPLOAD_NEW_ASSET_VERSION_FAILED,
  UPLOADING_NEW_ASSET_VERSION_PROGRESS,
  UPLOAD_NEW_ASSET_VERSION_CANCEL,

  FETCHING_ASSET_ANALYTICS_REQUEST,
  FETCHING_ASSET_ANALYTICS_SUCCEDDED,
  FETCHING_ASSET_ANALYTICS_FAILED,

  FETCHING_ASSET_PREVIEW,
  FETCHING_ASSET_PREVIEW_SUCCEDDED,
  FETCHING_ASSET_PREVIEW_FAILED,
  FETCHING_ASSET_PREVIEW_TEXT,
  FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED,
  FETCHING_ASSET_PREVIEW_TEXT_FAILED,
  FETCHING_PREVIEW_HTML_TEMPLATE,
  FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED,
  FETCHING_PREVIEW_HTML_TEMPLATE_FAILED,

  RECORDING_ASSET_SESSION_EVENT_REQUEST,
  RECORDING_ASSET_SESSION_EVENT_SUCCEDDED,
  RECORDING_ASSET_SESSION_EVENT_FAILED,

  CAPTURED_ASSET_VIDEO_NEW_RANGE,
  UPDATED_ASSET_VIDEO_RANGE,
  REMOVED_ASSET_VIDEO_RANGE,
  SYNCING_ASSET_VIEW_RANGE_REQUEST,
  SYNCING_ASSET_VIEW_RANGE_SUCCEDDED,
  SYNCING_ASSET_VIEW_RANGE_FAILED,

  ADD_ASSET_URL,
  ADD_ASSET_URL_SUCCEDDED,
  ADD_ASSET_URL_FAILED,

  CLONING_ASSET_REQUEST,
  CLONING_ASSET_SUCCEDDED,
  CLONING_ASSET_FAILED,

  FETCHING_RECOMMENDED_ASSETS,
  FETCHING_RECOMMENDED_ASSETS_SUCCEDDED,
  FETCHING_RECOMMENDED_ASSETS_FAILED,
  INVALIDATE_RECOMMENDED_ASSETS,

  UPDATING_PAGES_TO_ASSET_REQUEST,
  UPDATING_PAGES_TO_ASSET_SUCCEDDED,
  UPDATING_PAGES_TO_ASSET_FAILED,
  INVALIDATE_MERGE_TASK,

  WS_ASSET_PROCESSED,
  WS_ASSET_MERGE_STATUS,

  ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE,
  INVALIDATE_ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE,

  FETCHING_DUPLICATE_ASSET,
  FETCHING_DUPLICATE_ASSET_SUCCEEDED,
  TOGGLE_ASSET_TO_CONTENT_SIMILARITY_QUEUE,

  CREATING_ASSET_FROM_HUB,
  CREATING_ASSET_FROM_HUB_SUCCEEDED,
  CREATING_ASSET_FROM_HUB_FAILED,

  CREATING_ASSET_ID,
  INVALIDATE_SELECTED_ASSET_ID,
  INVALIDATE_PROCESSED_ASSET_ID,
  FETCHING_FREQUENTLY_SHARED_ASSETS,
  FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED,
  FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED,

  FETCHING_CONTENT_RECOMMENDATIONS_REQUEST,
  FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED,
  FETCHING_CONTENT_RECOMMENDATIONS_FAILED,

  UPDATING_ASSET_SUBTITLE_SUCCEDDED,
  UPDATING_ASSET_SUBTITLE,
  UPDATING_ASSET_SUBTITLE_FAILED,
  FETCHING_ASSET_INSIGHTS_REQUEST,
  FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED,
  FETCHING_ASSET_INSIGHTS_REQUEST_FAILED,
  FETCHING_ASSET_STORAGE_LIMIT,
  FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED,
  FETCHING_ASSET_STORAGE_LIMIT_FAILED,

} from '../actions/actionTypes.jsx';

import _ from 'lodash';

const initialSessionState = {
  id: null,
  creating: false,
  updating: false,
  preparing: false,
  fetching: false,
  page: {
    index: 0,
    creating: false,
    updating: false
  },
  ranges: [],
  selectedAssetId: null
};

const initialState = {
  loading: false,
  updating: false,
  grid_view: false,
  upload: {
    uploading: false,
    progress: 0,
    file: null,
    source: null
  },
  invalidated: true,
  item: null,
  analytics: {
    loading: false,
    item: null
  },
  session: {
    ...initialSessionState
  },
  preview: {
    loading: false,
    item: null
  },
  merge: {
    merging: false,
    initiated: false,
    merged: false,
    items: [],
    error: null,
    status: null
  },
  customer: {
    item: null,
    type: 'ANONYMOUS',
    generating: false,
    error: null,
    updateLink: {
      updating: false,
      item: null,
      error: null
    }
  },
  utmCampaignLinks: {
    loading: false,
    invalidated: true,
    currentPage: -1,
    totalPages: 0,
    loadMore: true,
    items: [],
    deleting: false
  },
  urlAsset: {
    creating: false,
    error: null
  },
  cloneAsset: {
    cloning: false,
    item: null,
    error: null
  },
  recommended: {
    loading: false,
    items: [],
    error: null
  },
  similarity: [],
  error: null,
  subtitle: {
    updating: false,
    success: false,
    error: null
  },
  insights: {
    loading: false,
    item: null,
    error: null
  },
  seekPrompts: [],
};

function assetReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_ASSET:
      return Object.assign({}, state, {
        loading: true,
        item: null,
        errors: null,
        invalidated: true,
        preview: {
          loading: false,
          item: null
        },
        recommended: {
          loading: false,
          items: [],
          error: null
        }
      })
    case FETCHING_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        loading: false,
        invalidated: false,
        item: action.payload,
        errors: null
      })
    case FETCHING_ASSET_FAILED:
      return Object.assign({}, state, {
        loading: false,
        invalidated: false,
        errors: action.payload.errors
      })
    case INVALIDATE_ASSET:
      return Object.assign({}, state, initialState)

    case FETCHING_FREQUENTLY_SHARED_ASSETS:
      return Object.assign({}, state, {
        ...state,
        frequentlySharedAssets: {
          data: [],
          loading: true
        }
      })


    case FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        frequentlySharedAssets: {
          loading: false,
          data: action.payload.data
        }
      })

    case FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        frequentlySharedAssets: {
          ...state.frequentlySharedAssets,
          loading: false,
          error: action.payload.error
        }
      })

    case FETCHING_ASSET_ANALYTICS_REQUEST:
      var assetId = action.payload.assetId;

      if (!state.item || assetId != state.item.id) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        analytics: {
          loading: true,
          item: null
        }
      })
    case FETCHING_ASSET_ANALYTICS_SUCCEDDED:
      var assetId = action.payload.context.assetId;

      if (!state.item || assetId != state.item.id) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        analytics: {
          loading: false,
          item: action.payload.response
        }
      })
    case FETCHING_ASSET_ANALYTICS_FAILED:
      var assetId = action.payload.context.assetId;

      if (!state.item || assetId != state.item.id) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        analytics: {
          loading: false,
          item: null,
          errors: action.payload.error
        }
      })


    case FAVORITING_ASSET_REQUEST:
      return Object.assign({}, state, {
        ...state,
        favorating: true
      })
    case FAVORITING_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        item: {
          ...state.item,
          favorite: true
        },
        favorating: false
      })
    case FAVORITING_ASSET_FAILED:
      return Object.assign({}, state, {
        ...state,
        favorating: false
      })


    case UNFAVORITING_ASSET_REQUEST:
      return Object.assign({}, state, {
        ...state,
        favorating: true
      })
    case UNFAVORITING_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          favorite: false
        },
        favorating: false
      })
    case UNFAVORITING_ASSET_FAILED:
      return Object.assign({}, state, {
        ...state,
        favorating: false
      })

    case UPDATING_ASSET:
      return Object.assign({}, state, {
        ...state,
        updating: true
      })
    case UPDATING_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        updating: false,
        item: action.payload.asset,
        errors: null
      })
    case UPDATING_ASSET_FAILED:
      return Object.assign({}, state, {
        ...state,
        updating: false,
        errors: action.payload.error
      })

    case UPLOAD_NEW_ASSET_VERSION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        upload: {
          uploading: true,
          progress: 0,
          file: action.payload.file,
          source: action.payload.source
        }
      })
    case UPLOAD_NEW_ASSET_VERSION_SUCCEDDED:
      var tags = new Array();

      tags = _.get(action,'payload.tags', [])
      
      return Object.assign({}, state, {
        ...state,
        item: {
          ...action.payload,
          tags: tags
        },
        upload: {
          uploading: false,
          progress: 0,
          file: null,
          source: null
        }
      })
    case UPLOAD_NEW_ASSET_VERSION_FAILED:
      return Object.assign({}, state, {
        ...state,
        upload: {
          uploading: false,
          progress: 0,
          file: null,
          source: null,
          error: action.payload.error
        }
      })

    case UPLOADING_NEW_ASSET_VERSION_PROGRESS:
      return Object.assign({}, state, {
        ...state,
        upload: {
          ...state.upload,
          progress: action.payload.progress,
        }
      })
    case UPLOAD_NEW_ASSET_VERSION_CANCEL:
      return Object.assign({}, state, {
        ...state,
        upload: {
          uploading: false,
          progress: 0,
          file: null,
          source: null
        }
      })

    case FETCHING_ASSET_PREVIEW:
      var id = action.payload.id;

      if (!state.item || state.item.id != id) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          loading: true
        }
      })

    case FETCHING_ASSET_PREVIEW_SUCCEDDED:
      var id = action.payload.id;
      var result = action.payload.result;

      if (!state.item || state.item.id != id) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          item: result
        }
      })

    case FETCHING_ASSET_PREVIEW_FAILED:
      var id = action.payload.id;
      var error = action.payload.error;

      if (!state.item || state.item.id != id) {
        return state;
      }

      return Object.assign({}, state, {
        preview: {
          ...state.preview,
          error: error
        }
      })

    case FETCHING_ASSET_PREVIEW_TEXT:
      return {
        ...state,
        preview: {
          ...state.preview,
          item: {
            ...state.preview.item,
            loading: true
          }
        }
      }

    case FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED:

      var previewPages = _.get(state, 'preview.item.pages') || [];

      var pages = previewPages.map((page, index) => {
        var response = action.payload.pages[index];
        return {
          ...page,
          width: response.width,
          height: response.height,
          texts: response.texts
        }
      });

      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          item: {
            ...state.preview.item,
            pages: pages,
            fonts: action.payload.fonts,
            loading: false
          }
        }
      });
    case FETCHING_ASSET_PREVIEW_TEXT_FAILED:
      return Object.assign({}, state, {
        preview: {
          ...state.preview,
          error: action.payload,
          item: {
            ...state.preview.item,
            loading: false
          }
        }
      })

    case FETCHING_PREVIEW_HTML_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          loading: true
        }
      })

    case FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED:

      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          htmlPreview: action.payload.html,
          loading: false
        }
      });

    case FETCHING_PREVIEW_HTML_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        preview: {
          ...state.preview,
          error: action.payload,
          loading: false
        }
      })

    case RECORDING_ASSET_SESSION_EVENT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        session: {
          ...initialSessionState
        }
      })
    case RECORDING_ASSET_SESSION_EVENT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          id: action.payload.id,
          creating: false
        }
      })

    case RECORDING_ASSET_SESSION_EVENT_FAILED:
      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          id: null,
          creating: false,
          error: action.payload
        }
      })

    case FETCHING_ASSET_PREVIEW:
      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          loading: true
        }
      })
    case FETCHING_ASSET_PREVIEW_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          item: action.payload
        }
      })
    case FETCHING_ASSET_PREVIEW_FAILED:
      return Object.assign({}, state, {
        preview: {
          ...state.preview,
          error: action.payload
        }
      })

    case CAPTURED_ASSET_VIDEO_NEW_RANGE:
      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: [
            ...state.session.ranges,
            action.payload
          ]
        }
      })

    case UPDATED_ASSET_VIDEO_RANGE:
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == action.payload.id) {
          return {
            ...range,
            end: Math.max(range.start, range.end, action.payload.end),
            updatedDate: action.payload.updatedDate,
            synced: false
          }
        }

        return range;
      });

      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })

    case REMOVED_ASSET_VIDEO_RANGE:
      var ranges = [...state.session.ranges].filter((range) => {
        return range.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })

    case SYNCING_ASSET_VIEW_RANGE_REQUEST:
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == action.payload.id) {
          return {
            ...range,
            syncing: true
          }
        }

        return range;
      });

      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })

    case SYNCING_ASSET_VIEW_RANGE_SUCCEDDED:
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == action.payload.id) {
          return {
            ...range,
            syncing: false,
            synced: true,
            external_id: action.payload.range.rangeId,
            syncedDate: new Date()
          }
        }

        return range;
      });

      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })
    case SYNCING_ASSET_VIEW_RANGE_FAILED:
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == action.payload.id) {
          return {
            ...range,
            syncing: false
          }
        }

        return range;
      });

      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })

    case ADD_ASSET_URL:
      return Object.assign({}, state, {
        ...state,
        urlAsset: {
          creating: true,
          error: null
        }
      })


    case ADD_ASSET_URL_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        urlAsset: {
          creating: false,
          error: null
        }
      })

    case ADD_ASSET_URL_FAILED:
      return Object.assign({}, state, {
        ...state,
        urlAsset: {
          creating: false,
          error: action.payload.error
        }
      })

    case CLONING_ASSET_REQUEST:
      return Object.assign({}, state, {
        ...state,
        cloneAsset: {
          cloning: true,
          error: null
        }
      })

    case CLONING_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        cloneAsset: {
          cloning: false,
          item: action.payload,
          error: null
        }
      })

    case CLONING_ASSET_FAILED:
      return Object.assign({}, state, {
        ...state,
        cloneAsset: {
          cloning: false,
          item: null,
          error: action.payload.error
        }
      })

    case FETCHING_RECOMMENDED_ASSETS:
      return Object.assign({}, state, {
        ...state,
        recommended: {
          loading: true,
          items: [],
          error: null
        }
      })

    case FETCHING_RECOMMENDED_ASSETS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        recommended: {
          loading: false,
          items: action.payload,
          error: null
        }
      })

    case FETCHING_RECOMMENDED_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        recommended: {
          loading: false,
          items: [],
          error: action.payload
        }
      })

    case INVALIDATE_RECOMMENDED_ASSETS:
      return Object.assign({}, state, {
        ...state,
        recommended: {
          loading: false,
          items: [],
          error: null
        }
      })

    case UPDATING_PAGES_TO_ASSET_REQUEST:
      return Object.assign({}, state, {
        ...state,
        merge: {
          ...state.merge,
          merging: true
        },
        preparing: true
      })

    case UPDATING_PAGES_TO_ASSET_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        merge: {
          ...state.merge,
          merging: false,
          initiated: true
        },
        preparing: true
      })

    case UPDATING_PAGES_TO_ASSET_FAILED:
      return Object.assign({}, state, {
        ...state,
        merge: {
          ...state.merge,
          merging: false,
          error: action.payload.errors
        },
        preparing: false
      })

    case INVALIDATE_MERGE_TASK:
      return Object.assign({}, state, {
        ...state,
        merge: {
          merging: false,
          initiated: false,
          merged: false,
          error: null,
          status: null
        }
      })

    case WS_ASSET_MERGE_STATUS:
      return Object.assign({}, state, {
        ...state,
        merge: {
          ...state.merge,
          status: action.payload.status
        }
      })

    case WS_ASSET_PROCESSED:
      var processedAsset = action.payload.id;
      var id = _.get(state, 'item.id') || null;
      var similarityQueue = _.get(state, 'similarity');
      const assetProcessingStatus = action.payload.status;
      const merged = assetProcessingStatus === "OK" ? true : false;

      // removed similariy queue for now || _.isEmpty(similarityQueue)

      if (processedAsset != id) {
        return Object.assign({}, state, {
          ...state,
          merge: {
            ...state.merge,
            status: assetProcessingStatus,
            merged: merged
          },
          processedAsset: processedAsset,
        })
      }

      const canEdit = _.get(state, 'item.canEdit');
      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          ...action.payload,
          canEdit: canEdit
        },
        merge: {
          ...state.merge,
          status: assetProcessingStatus,
          merged: processedAsset === id
        },
        processedAsset: processedAsset
      });

    case FETCHING_DUPLICATE_ASSET:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        similarity: {
          ...state.similarity,
          [id]: {
            ...state.similarity[id],
            processing: true,
            processed: false,
            similarAsset: null
          }
        }
      });

    case FETCHING_DUPLICATE_ASSET_SUCCEEDED:
      var id = action.payload.asset.id;

      if (action.payload.similarAssets && action.payload.similarAssets.length > 0) {
        return Object.assign({}, state, {
          ...state,
          similarity: {
            ...state.similarity,
            [id]: {
              ...state.similarity[id],
              processing: false,
              processed: true,
              similarAsset: action.payload.similarAssets[0]
            }
          }
        });
      }

      return state;

    case CREATING_ASSET_FROM_HUB:

      return Object.assign({}, state, {
        ...state,
        creating: true,
        preparing: true
      });

    case CREATING_ASSET_FROM_HUB_SUCCEEDED:

      return Object.assign({}, state, {
        ...state,
        creating: false,
        preparing: true

      });

    case CREATING_ASSET_FROM_HUB_FAILED:

      return Object.assign({}, state, {
        ...state,
        creating: false,
        preparing: false

      });

    case CREATING_ASSET_ID:
      const processing = action.payload.processing ? action.payload.processing : false;

      return Object.assign({}, state, {
        ...state,
        selectedAssetId: action.payload.id,
        processingAsset: processing
      })

    case INVALIDATE_SELECTED_ASSET_ID:

      return Object.assign({}, state, {
        ...state,
        selectedAssetId: null,
        processingAsset: false
      })

    case INVALIDATE_PROCESSED_ASSET_ID:

      return Object.assign({}, state, {
        ...state,
        processedAsset: null,
        preparing: false
      })

    case FETCHING_CONTENT_RECOMMENDATIONS_REQUEST:

      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: true
        }
      }

    case FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED:

      var items = _.slice(action.payload, 0, 9);

      return {
        ...state,
        recommendedAssets: {
          loading: false,
          items: items
        }
      }

    case FETCHING_CONTENT_RECOMMENDATIONS_FAILED:
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: false,
          error: action.payload
        }
      }

    case UPDATING_ASSET_SUBTITLE:
      return Object.assign({}, state, {
        ...state,
        subtitle: {
          updating: true,
          success: false,
          error: null
        }
      })

    case UPDATING_ASSET_SUBTITLE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        item: action.payload,
        subtitle: {
          updating: false,
          success: true,
          error: null
        }
      })

    case UPDATING_ASSET_SUBTITLE_FAILED:
      return Object.assign({}, state, {
        ...state,
        subtitle: {
          updating: false,
          success: false,
          error: action.payload
        }

      })

    case FETCHING_ASSET_INSIGHTS_REQUEST: 
      return Object.assign({}, state, {
        ...state,
        insights: {
          loading: true,
          item: null
        }
      })
    
    case FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        insights: {
          loading: false,
          item: action.payload
        }
      })
    
    case FETCHING_ASSET_INSIGHTS_REQUEST_FAILED:
      return Object.assign({}, state, {
        ...state,
        insights: {
          loading: false,
          item: null,
          error: action.payload
        }
      })

    case FETCHING_ASSET_STORAGE_LIMIT:
      return Object.assign({} , state, {
        ...state,
        storageLimit:{
          fetching: true,
          error: null,
          paperfliteAssets: {},
          contentSource:{}
        }
      })

    case FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED:
      const response = action.payload;

      return Object.assign({} , state, {
        ...state,
        storageLimit: {
          fetching: false,
          error: null,
          paperfliteAssets: { assetStorageUsed: _.get(response, 'assetStorageUsed', 0), assetStorageLimit: _.get(response, 'assetStorageLimit', 0)},
          contentSource: { datasourceFilesUsed: _.get(response, 'datasourceFilesUsed', 0), datasourceFilesLimit: _.get(response, 'datasourceFilesLimit', 0)}
        }
      })
     case FETCHING_ASSET_STORAGE_LIMIT_FAILED:
      return Object.assign({} , state, {
        ...state,
        storageLimit:{
          fetching: false,
          result: _.get(state,"storageLimit.result", []),
          error: action.payload.error,
        }
      })

    default:
      return state
  }
}

export {
  assetReducer
};